import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from "rxjs";
import { SharedFormService } from "src/app/shared-utility/services/shared-form.service";

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {

  @Output() closePopup = new EventEmitter<boolean>();
  @Output() confirmExit = new EventEmitter<boolean>();
  @Output() confirmESign = new EventEmitter<boolean>();
  @Output() setCheckBox = new EventEmitter<string>();
  // @Output() setPatientEmail = new EventEmitter<string>();
  lupus: boolean = false;
  nephritis: boolean = false;
  consentEmail: string = "";

  confirmHandler() {
    this.formData.lupus.next(this.lupus);
    this.formData.nephritis.next(this.nephritis);
    this.formData.consentEmail.next(this.consentEmail);
    this.setCheckBox.emit(this.popupHeader);
    // this.setPatientEmail.emit(this.consentEmail);
    this.closePopup.emit(true);
  }

  close() {
    // this.setCheckBox.emit(this.popupHeader);
    this.closePopup.emit(true);
    this.formData.confirmExit.next(false);
    this.formData.confirmDelete.next(false);
  }

  confirm() {
    if (this.childComponent === "ESign") {
      this.confirmESign.emit(true);
    } else if (this.childComponent === "deleteData") {
      this.formData.confirmDelete.next(true);
    } else {
      this.formData.confirmExit.next(true)
    }
  }

  checkbox() {
    if (this.lupus || this.nephritis) {
      return true;
    }
    else {
      return false;
    }
  }


  @Input() popupHeader: string;
  @Input() popupText: string;
  @Input() isImg: boolean;
  @Input() isImgDel: boolean;
  @Input() noOfButtons: string;
  @Input() texttype: string;
  @Input() childComponent: string;
  @Input() diagnosisICD: string;
  @Input() otherDiagnosisText: string;
  @Input() isEsignPopup: boolean;
  @Input() patientEmail: string;

  constructor(private formData: SharedFormService) {
    this.formData.lupus.subscribe((evt) => {
      this.lupus = evt;
    });
    this.formData.nephritis.subscribe((evt) => {
      this.nephritis = evt;
    });
    this.formData.consentEmail.subscribe((evt) => {
      this.consentEmail = evt;
    });

  }

  ngOnInit() {
    this.formData.consentEmail.subscribe((evt) => {
      this.consentEmail = evt;
    });
    // if(this.patientEmail && this.patientEmail.length > 0){
    //   this.consentEmail = this.patientEmail;
    // }
  }
  ngAfterViewInit() {

    this.registerDragElement();

  }




  private registerDragElement() {

    const elmnt = document.getElementById('headerPop');




    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;




    const dragMouseDown = (e) => {

      e = e || window.event;

      // get the mouse cursor position at startup:

      pos3 = e.clientX;

      pos4 = e.clientY;

      document.onmouseup = closeDragElement;

      // call a function whenever the cursor moves:

      document.onmousemove = elementDrag;

    };




    const elementDrag = (e) => {

      e = e || window.event;

      // calculate the new cursor position:

      pos1 = pos3 - e.clientX;

      pos2 = pos4 - e.clientY;

      pos3 = e.clientX;

      pos4 = e.clientY;

      // set the element's new position:

      elmnt.style.top = elmnt.offsetTop - pos2 + 'px';

      elmnt.style.left = elmnt.offsetLeft - pos1 + 'px';

    };




    const closeDragElement = () => {

      /* stop moving when mouse button is released:*/

      document.onmouseup = null;

      document.onmousemove = null;

    };




    if (document.getElementById(elmnt.id + 'Content')) {

      /* if present, the header is where you move the DIV from:*/

      document.getElementById(elmnt.id + 'Content').onmousedown = dragMouseDown;

    } else {

      /* otherwise, move the DIV from anywhere inside the DIV:*/

      elmnt.onmousedown = dragMouseDown;

    }

  }
}
